/* eslint-disable */
import React, { useRef, useState } from 'react';
import {
  Download,
  FileText,
  FileUp,
  ChevronLeft,
  Home,
  Edit2,
  ChevronDown,
  Map,
  Edit,
  Check,
  Users,
  Globe,
  Link,
  Image,
  Trash2,
  Shield,
} from 'lucide-react';
import { Button, TextField, Box, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import appConfig from '../../config';
import Swal from 'sweetalert2';
import { deleteUploads, updateProperty, uploadFile } from 'src/helper/backend_helper';
import { MapContainer, TileLayer, Polygon, useMapEvents, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import currIcon from '../../assets/location.png';
import ImageManager from './ImageManger';
import BedConfigurator from './BedConfigurator';
import AmenitySelector from './AmenitySelector';
import { PropertyExport } from './propertyExport';

const icon = L.divIcon({
  html: `
        <div style="
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%; /* Fully rounded */
          width: 40px; /* Width of the marker */
          height: 40px; /* Height of the marker */
          padding:0
        ">
          <img 
            src="${currIcon}" 
            alt="bag-icon" 
            style="width: 60%; height: 60%;" 
          />
        </div>
      `,
  iconSize: [40, 40], // Matches the size of the outer div
  iconAnchor: [20, 40], // Anchor at the bottom center
  popupAnchor: [0, -40], // Popup above the marker
  className: '',
});

const sampleAmenities = [
  {
    id: '1',
    name: {
      it: 'Wi-Fi',
      en: 'Wi-Fi',
    },
    icon: 'wifi',
    selected: false,
  },
  {
    id: '2',
    name: {
      it: 'Aria Condizionata',
      en: 'Air Conditioning',
    },
    icon: 'airVent',
    selected: false,
  },
  {
    id: '3',
    name: {
      it: 'Piscina',
      en: 'Swimming Pool',
    },
    icon: 'droplet',
    selected: false,
  },
  {
    id: '4',
    name: {
      it: 'Parcheggio',
      en: 'Parking',
    },
    icon: 'car',
    selected: false,
  },
  {
    id: '5',
    name: {
      it: 'TV',
      en: 'TV',
    },
    icon: 'tv',
    selected: false,
  },
  {
    id: '6',
    name: {
      it: 'Lavatrice',
      en: 'Washing Machine',
    },
    icon: 'washing-machine',
    selected: false,
  },
  {
    id: '7',
    name: {
      it: 'Lavastoviglie',
      en: 'Dishwasher',
    },
    icon: 'cpu',
    selected: false,
  },
  {
    id: '8',
    name: {
      it: 'Balcone',
      en: 'Balcony',
    },
    icon: 'palmtree',
    selected: false,
  },
  {
    id: '9',
    name: {
      it: 'Riscaldamento',
      en: 'Heating',
    },
    icon: 'flame',
    selected: false,
  },
  {
    id: '10',
    name: {
      it: 'Giardino',
      en: 'Garden',
    },
    icon: 'flower',
    selected: false,
  },
  {
    id: '11',
    name: {
      it: 'Vista Mare',
      en: 'Sea View',
    },
    icon: 'mountain',
    selected: false,
  },
  {
    id: '12',
    name: {
      it: 'Barbecue',
      en: 'Barbecue',
    },
    icon: 'utensils',
    selected: false,
  },
  {
    id: '13',
    name: {
      it: 'Asciugacapelli',
      en: 'Hair Dryer',
    },
    icon: 'wind',
    selected: false,
  },
  {
    id: '14',
    name: {
      it: 'Ferro da Stiro',
      en: 'Iron',
    },
    icon: 'shirt',
    selected: false,
  },
  {
    id: '15',
    name: {
      it: 'Cassaforte',
      en: 'Safe Box',
    },
    icon: 'lock',
    selected: false,
  },
  {
    id: '16',
    name: {
      it: 'Area Lavoro',
      en: 'Workspace',
    },
    icon: 'briefcase',
    selected: false,
  },
];

export default function PropertyDetail() {
  const [activeTab, setActiveTab] = useState('company');
  const navigate = useNavigate();
  const location = useLocation();
  const { data, property } = location.state;
  // console.log(property);
  const [propertyNotes, setPropertyNotes] = useState(property?.propertyNotes || '');
  const [listings, setListings] = useState({
    airbnb: property?.listings?.airbnb || '',
    booking: property?.listings?.booking || '',
    agoda: property?.listings?.agoda || '',
    other: property?.listings?.other || '',
  });

  const [policeUserName, setPoliceUserName] = useState(property?.policeUserName || '');
  const [policePassword, setPolicePassword] = useState(property?.policePassword || '');
  const [policeApiKey, setPoliceApiKey] = useState(property?.policeApiKey || '');
  const [tourismTaxLoginEmail, setTourismTaxLoginEmail] = useState(property?.tourismTaxLoginEmail || '');
  const [tourismTaxLoginPassword, setTourismTaxLoginPassword] = useState(property?.tourismTaxLoginPassword || '');
  const [tourismTaxLoginUrl, setTourismTaxLoginUrl] = useState(property?.tourismTaxLoginUrl || '');
  const [cin, setCin] = useState(property?.cin || '');
  const [cis, setCis] = useState(property?.cis || '');

  const [loading, setLoading] = useState(false);

  const handleDownloadContract = (file) => {
    const fileUrl = `${appConfig.FILE_URL}${file}`;
    window.open(fileUrl, '_blank');
  };

  const handleSaveNotes = async () => {
    try {
      setLoading(true);

      const submitData = {
        propertyNotes,
      };

      await updateProperty(property?._id, submitData);
      Swal.fire({
        icon: 'success',
        title: 'Property notes updated successfully',
      });
      setLoading(false);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update',
      });
    }
  };

  const handleSaveListing = async () => {
    try {
      setLoading(true);

      const submitData = {
        listings,
      };

      await updateProperty(property?._id, submitData);
      Swal.fire({
        icon: 'success',
        title: 'Property listings updated successfully',
      });
      setLoading(false);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update',
      });
    }
  };

  const handleSavePoliceTouristTax = async () => {
    try {
      setLoading(true);

      const submitData = {
        policeUserName,
        policePassword,
        policeApiKey,
        tourismTaxLoginEmail,
        tourismTaxLoginPassword,
        tourismTaxLoginUrl,
        cin,
        cis,
      };

      await updateProperty(property?._id, submitData);
      Swal.fire({
        icon: 'success',
        title: 'Police and Tourism Tax updated successfully',
      });
      setLoading(false);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update',
      });
    }
  };

  const [touristRentalCommunication, setTouristRentalCommunication] = useState(
    property?.touristRentalCommunication || ''
  );

  const handleTouristRentalUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Upload logic (replace with your actual API call)
    const uploadedUrl = await uploadFile({ file }, { headers: { 'Content-Type': 'multipart/form-data' } }); // Should return a URL

    setTouristRentalCommunication(uploadedUrl.data.data.fileName); // Update state
    try {
      const submitData = {
        touristRentalCommunication: uploadedUrl.data.data.fileName,
      };
      await updateProperty(property?._id, submitData);
      Swal.fire({
        icon: 'success',
        title: 'Tourist Rental Communication updated successfully',
      });
      const data = {
        filename: touristRentalCommunication,
      };
      touristRentalCommunication && (await deleteUploads(data, { headers: { 'Content-Type': 'application/json' } }));
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update',
      });
    }
  };

  const [policePortalFiles, setPolicePortalFiles] = useState(property?.policePortal || []);

  const handlePolicePortalUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const uploadedUrl = await uploadFile({ file }, { headers: { 'Content-Type': 'multipart/form-data' } }); // your upload function
    setPolicePortalFiles((prev) => [uploadedUrl.data.data.fileName]); // Update state with new file

    // Optional: update on backend as well
    // await api.updatePropertyPolicePortal([...policePortalFiles, uploadedUrl]);
    try {
      const submitData = {
        policePortal: [uploadedUrl.data.data.fileName],
      };
      await updateProperty(property?._id, submitData);
      Swal.fire({
        icon: 'success',
        title: 'Police Portal updated successfully',
      });

      await Promise.all(
        policePortalFiles.map(async (image) => {
          const data = {
            filename: image,
          };
          await deleteUploads(data, { headers: { 'Content-Type': 'application/json' } }); // Delete each image
        })
      );
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update',
      });
    }
  };

  const [additionalDocuments, setAdditionalDocuments] = useState(property?.additionalDocuments || []);
  const additionalDocRef = useRef(null);

  const handleAdditionalDocUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files || files.length === 0) return;

    try {
      const uploadPromises = files.map((file) =>
        uploadFile({ file }, { headers: { 'Content-Type': 'multipart/form-data' } })
      );

      const uploaded = await Promise.all(uploadPromises);
      const fileNames = uploaded.map((res) => res?.data?.data?.fileName);

      const updatedDocs = [...(additionalDocuments || []), ...fileNames];

      setAdditionalDocuments(updatedDocs);
      const submitData = {
        additionalDocuments: updatedDocs,
      };
      await updateProperty(property?._id, submitData);

      Swal.fire({
        icon: 'success',
        title: 'Documents uploaded successfully',
      });

      // Optionally update local state if needed
      // setAdditionalDocs(updatedDocs);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Upload Failed',
        text: 'Could not upload additional documents.',
      });
    }
  };

  const handleDeleteDocument = async (docToDelete) => {
    try {
      // 1. Delete from upload server
      const data = { filename: docToDelete };
      await deleteUploads(data, {
        headers: { 'Content-Type': 'application/json' },
      });

      // 2. Filter out the deleted document locally
      const updatedDocs = additionalDocuments.filter((doc) => doc !== docToDelete);

      // 3. Update property on backend
      await updateProperty(property?._id, {
        additionalDocuments: updatedDocs,
      });

      // 4. Show success alert
      Swal.fire({
        icon: 'success',
        title: 'Document deleted successfully',
      });

      // 5. Update frontend state (if using useState)
      setAdditionalDocuments(updatedDocs);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to delete the document',
      });
    }
  };

  const [isMapDialogOpen, setIsMapDialogOpen] = useState(false);
  const [isLocationSaving, setIsLocationSaving] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(
    property?.location?.coordinates.length > 0
      ? { lat: property?.location?.coordinates[1], lng: property?.location?.coordinates[0] }
      : null
  );

  const MapClickHandler = () => {
    useMapEvents({
      click(e) {
        setSelectedLocation({ lat: e.latlng.lat, lng: e.latlng.lng });
      },
    });
    return null;
  };

  const handleSaveLocation = async () => {
    try {
      setIsLocationSaving(true);
      const data = { location: { type: 'Point', coordinates: [selectedLocation.lng, selectedLocation.lat] } };

      await updateProperty(property?._id, data);

      Swal.fire({
        icon: 'success',
        title: 'Location saved successfully',
      });
      setIsMapDialogOpen(false);
      setIsLocationSaving(false);
    } catch (error) {
      setIsLocationSaving(false);

      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to delete the document',
      });
    }
  };

  const [beds, setBeds] = useState(property?.beds || []);
  const [maxGuests, setMaxGuests] = useState(0);
  const [manualMaxGuests, setManualMaxGuests] = useState(property?.manualMaxGuests || 0);

  const handleBedsChange = async (beds) => {
    try {
      setBeds(beds); // Update local state
      await updateProperty(property?._id, { beds });
      Swal.fire({
        icon: 'success',
        title: 'Beds updated successfully',
      });
    } catch (error) {
      setIsLocationSaving(false);

      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to delete the document',
      });
    }
  };

  const handleGuestCountChange = async (count) => {
    setMaxGuests(count);
    await updateProperty(property?._id, {
      maxGuests: count,
    });
  };

  const [amenities, setAmenities] = useState(property?.amenities?.length > 0 ? property?.amenities : sampleAmenities);

  const handleAmenitiesChange = async (updatedAmenities) => {
    try {
      setAmenities(updatedAmenities);
      await updateProperty(property?._id, {
        amenities: updatedAmenities,
      });
      Swal.fire({
        icon: 'success',
        title: 'Amenities updated successfully',
      });
    } catch (error) {
      setIsLocationSaving(false);

      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to delete the document',
      });
    }
  };
  console.log(property);
  const handleExport = () => {
    console.log('property');
    PropertyExport(property, `${property?.name}.xlsx`);
  };

  return (
    <>
      <div className="flex flex-col w-full">
        {/* Top navigation bar */}
        <div className="w-full p-4 flex items-center justify-between border-b border-gray-200">
          <div onClick={() => navigate(-1)} className="flex items-center cursor-pointer">
            <ChevronLeft className="text-blue-600" size={20} />
            <span className="text-blue-600 ml-1">Back</span>
          </div>
        </div>

        {/* Company header with export option */}
        <div className="w-full px-6 py-4 flex flex-col">
          <div
            onClick={() => navigate('/signed/owner_detail', { state: { data } })}
            className="flex items-center mb-4 cursor-pointer"
          >
            <ChevronLeft size={20} className="mr-2" />
            <span className="text-gray-800">Back to Company</span>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="bg-blue-100 p-2 rounded-md mr-3">
                <FileText size={24} className="text-blue-600" />
              </div>
              <h1 className="text-2xl font-bold">{property?.name}</h1>
            </div>

            <button
              className="flex items-center border border-gray-200 rounded-md px-4 py-2 text-gray-800 hover:bg-gray-50"
              onClick={() => handleExport()}
            >
              <FileText size={16} className="mr-2" />
              Export as CSV
            </button>
          </div>

          <div className="mt-2 text-gray-600">
            Owner:{' '}
            {data?.ownerType === 'private'
              ? data?.privateOwner?.firstName + ' ' + data?.privateOwner?.lastName
              : data?.companyOwner?.firstName + ' ' + data?.companyOwner?.lastName}
          </div>
        </div>
      </div>

      <div className="p-6 bg-white rounded-lg shadow-sm border border-gray-200">
        {/* Header */}
        <div className="flex items-center mb-8">
          <Home className="text-indigo-600 mr-2" size={24} />
          <h2 className="text-xl font-bold">Property Details</h2>
        </div>

        {/* Property Details Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Property Name */}
          <div>
            <p className="text-gray-500 text-sm mb-1">Property Name</p>
            <p className="text-gray-800 font-medium">{property?.name}</p>
          </div>

          {/* Address */}
          <div className="relative">
            <p className="text-gray-500 text-sm mb-1">Address</p>
            <div className="flex justify-between items-center">
              <p className="text-gray-800 font-medium pr-6">
                {property?.address} {property?.streetNumber}, {property?.city} , {property?.province} ,{' '}
                {property?.postalCode}
              </p>
            </div>
          </div>

          {/* Size */}
          <div className="relative">
            <p className="text-gray-500 text-sm mb-1">Size</p>
            <div className="flex justify-between items-center">
              <p className="text-gray-800 font-medium">{property?.size} m²</p>
            </div>
          </div>

          {/* Floor */}
          <div className="relative">
            <p className="text-gray-500 text-sm mb-1">Floor</p>
            <div className="flex justify-between items-center">
              <p className="text-gray-800 font-medium">{property?.floor}</p>
            </div>
          </div>

          {/* Manual Max Guests */}
          <div className="relative">
            <p className="text-gray-500 text-sm mb-1">Manual Max Guests</p>
            <div className="flex justify-between items-center">
              <p className="text-gray-800 font-medium">{property?.manualMaxGuests}</p>
            </div>
          </div>

          {/* Ownership Type */}
          <div className="relative">
            <p className="text-gray-500 text-sm mb-1">Ownership Type</p>
            <div className="flex justify-between items-center">
              <p className="text-gray-800 font-medium">{property?.ownershipType}</p>
            </div>
          </div>

          {/* Has Elevator */}
          <div>
            <p className="text-gray-500 text-sm mb-1">Has Elevator</p>
            <Box sx={{ minWidth: 260 }}>
              {/* <FormControl fullWidth size="small">
                <Select labelId="demo-simple-select-label" id="demo-simple-select">
                  <MenuItem selected value="Yes"> */}
              {property?.hasElevator ? 'Yes' : 'No'}
              {/* </MenuItem>
                </Select>
              </FormControl> */}
            </Box>
          </div>

          {/* Pet Policy */}
          <div>
            <p className="text-gray-500 text-sm mb-1">Pet Policy</p>
            <Box sx={{ minWidth: 260 }}>
              {/* <FormControl fullWidth size="small">
                <Select labelId="demo-simple-select-label" id="demo-simple-select">
                  <MenuItem selected value="Yes"> */}
              {property?.petPolicy}
              {/* </MenuItem>
                </Select>
              </FormControl> */}
            </Box>
          </div>

          {/* Map Location */}
          {/* <div>
            <p className="text-gray-500 text-sm mb-1">Map Location</p>
            <button className="flex items-center border border-gray-300 rounded px-3 py-2 text-indigo-600 bg-white">
              <Map size={18} className="mr-2" />
              <span>Set Location</span>
            </button>
          </div> */}

          <div>
            <p className="text-gray-500 text-sm mb-1">Map Location</p>
            <button
              className="flex items-center border border-gray-300 rounded px-3 py-2 text-indigo-600 bg-white"
              onClick={() => setIsMapDialogOpen(true)}
            >
              <Map size={18} className="mr-2" />
              <span>Set Location</span>
            </button>
          </div>

          <Dialog open={isMapDialogOpen} onClose={() => setIsMapDialogOpen(false)} fullWidth maxWidth="md">
            <DialogTitle>Select Location on Map</DialogTitle>
            <DialogContent>
              <div style={{ height: '400px', width: '100%' }}>
                <MapContainer center={[40.9155, 16.7596]} zoom={9} style={{ height: '100%', width: '100%' }}>
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution="&copy; OpenStreetMap contributors"
                  />
                  <MapClickHandler />{' '}
                  {selectedLocation && <Marker position={[selectedLocation.lat, selectedLocation.lng]} icon={icon} />}
                </MapContainer>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setIsMapDialogOpen(false)}>Cancel</Button>
              <Button
                variant="contained"
                onClick={() => handleSaveLocation()}
                disabled={!selectedLocation || isLocationSaving}
              >
                Save Location
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>

      <div className="p-6 bg-white rounded-lg shadow-sm border mt-3 border-gray-200">
        {/* Header */}
        <div className="flex items-center mb-2">
          <FileText className="text-indigo-600 mr-2" size={24} />
          <h2 className="text-xl font-bold">Property Notes</h2>
        </div>

        {/* Description text */}
        <p className="text-gray-500 mb-4">Add notes specific to this property</p>

        {/* Empty notes placeholder */}
        <div className="bg-gray-50 p-8 flex items-center justify-center mb-4 rounded">
          <textarea
            value={propertyNotes}
            onChange={(e) => setPropertyNotes(e.target.value)}
            className="w-full h-36 p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none"
            placeholder="No notes added yet. Click 'Edit Notes' to add some."
          />{' '}
        </div>

        {/* Edit button - right aligned */}
        <div className="flex justify-end">
          <button
            className="flex items-center space-x-2 bg-indigo-500 text-white py-3 px-8 rounded-lg hover:bg-indigo-600 transition-colors font-medium"
            onClick={() => handleSaveNotes()}
          >
            <Edit size={16} />
            <span>Save Notes</span>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 mt-3 gap-4">
        {/* Amenities Section */}
        <div className="p-6 bg-white rounded-lg shadow-sm border border-gray-200">
          {/* Header */}
          <div className="flex items-center mb-6">
            <Check className="text-indigo-600 mr-2" size={20} />
            <h2 className="text-xl font-bold">Amenities</h2>
          </div>

          {/* Amenities Grid */}
          {/* <div className="grid grid-cols-2 gap-4 mb-6">
            {property?.amenities
              .filter((item) => item.selected === true)
              .map((item) => (
                <div key={item.id} className="flex items-center">
                  <Check className="text-indigo-600 mr-2" size={16} />
                  <span>{item.name.en}</span>
                </div>
              ))}
          </div> */}

          {/* Edit button */}
          {/* <button className="flex items-center text-indigo-600 border border-gray-200 rounded px-4 py-2 hover:bg-indigo-50">
            <Edit2 size={16} className="mr-2" />
            <span>Edit Amenities</span>
          </button> */}

          <AmenitySelector amenities={amenities} onChange={handleAmenitiesChange} />
        </div>

        {/* Beds Section */}
        <div className="p-6 bg-white rounded-lg shadow-sm border border-gray-200">
          {/* Header */}
          <div className="flex items-center mb-6">
            <Users className="text-indigo-600 mr-2" size={20} />
            <h2 className="text-xl font-bold">Beds</h2>
          </div>

          {/* Beds List */}
          {/* <div className="mb-6 space-y-4">
            {property?.beds?.map((item) => (
              <div className="flex justify-between items-center">
                <span>{item?.type}</span>
                <span className="font-bold">×{item?.count}</span>
              </div>
            ))}
          </div> */}

          {/* Edit button */}
          {/* <button className="flex items-center text-indigo-600 border border-gray-200 rounded px-4 py-2 hover:bg-indigo-50">
            <Edit2 size={16} className="mr-2" />
            <span>Edit Beds</span>
          </button> */}
          <BedConfigurator
            // onBlur={handleSubmit}
            beds={beds}
            onChange={handleBedsChange}
            onGuestCountChange={handleGuestCountChange}
          />
        </div>
      </div>

      <div className="p-6 bg-white rounded-lg shadow-sm border mt-3 border-gray-200">
        {/* Header */}
        <div className="flex items-center mb-2">
          <Globe className="text-indigo-600 mr-2" size={24} />
          <h2 className="text-xl font-bold">Listings</h2>
        </div>

        {/* Description text */}
        <p className="text-gray-500 mb-6">Published listings for this property</p>

        {/* Listings content */}
        <div className="space-y-6 mb-6">
          <h3 className="font-medium ">Airbnb:</h3>
          <Box display="flex" alignItems="center" gap={2}>
            <Tooltip
              title="Copy link"
              onClick={() => {
                if (listings?.airbnb) {
                  navigator.clipboard.writeText(listings?.airbnb);
                }
              }}
            >
              <Link size={16} className="mr-2 text-blue-500 cursor-pointer" />
            </Tooltip>

            <TextField
              label="Airbnb"
              value={listings?.airbnb || ''}
              onChange={(e) => setListings((prevListings) => ({ ...prevListings, airbnb: e.target.value }))}
              fullWidth
              variant="outlined"
            />
          </Box>

          {/* <div>
            <h3 className="font-medium mb-2">Booking.com:</h3>
            <a
              href={property?.listings?.booking}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-blue-500 hover:underline"
            >
              <Link size={16} className="mr-2" />
              {property?.listings?.booking}
            </a>
          </div> */}
          <h3 className="font-medium">Booking.com:</h3>
          <Box display="flex" alignItems="center" gap={2}>
            <Tooltip
              title="Copy link"
              onClick={() => {
                if (listings?.booking) {
                  navigator.clipboard.writeText(listings?.booking);
                }
              }}
            >
              <Link size={16} className="mr-2 text-blue-500 cursor-pointer" />
            </Tooltip>

            <TextField
              label="Booking.com"
              value={listings?.booking || ''}
              onChange={(e) => setListings((prevListings) => ({ ...prevListings, booking: e.target.value }))}
              fullWidth
              variant="outlined"
            />
          </Box>

          {/* <div>
            <h3 className="font-medium mb-2">Agoda:</h3>
            <a
              href={property?.listings?.agoda}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-blue-500 hover:underline"
            >
              <Link size={16} className="mr-2" />
              {property?.listings?.agoda}
            </a>
          </div> */}

          <h3 className="font-medium">Agoda:</h3>
          <Box display="flex" alignItems="center" gap={2}>
            <Tooltip
              title="Copy link"
              onClick={() => {
                if (listings?.agoda) {
                  navigator.clipboard.writeText(listings?.agoda);
                }
              }}
            >
              <Link size={16} className="mr-2 text-blue-500 cursor-pointer" />
            </Tooltip>

            <TextField
              label="Agoda"
              value={listings?.agoda || ''}
              onChange={(e) => setListings((prevListings) => ({ ...prevListings, agoda: e.target.value }))}
              fullWidth
              variant="outlined"
            />
          </Box>

          {/* <div>
            <h3 className="font-medium mb-2">Other:</h3>
            <a
              href={property?.listings?.other}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-blue-500 hover:underline"
            >
              <Link size={16} className="mr-2" />
              {property?.listings?.other}
            </a>
          </div> */}

          <h3 className="font-medium ">Other:</h3>
          <Box display="flex" alignItems="center" gap={2}>
            <Tooltip
              title="Copy link"
              onClick={() => {
                if (listings?.other) {
                  navigator.clipboard.writeText(listings?.other);
                }
              }}
            >
              <Link size={16} className="mr-2 text-blue-500 cursor-pointer" />
            </Tooltip>

            <TextField
              label="Other"
              value={listings?.other || ''}
              onChange={(e) => setListings((prevListings) => ({ ...prevListings, other: e.target.value }))}
              fullWidth
              variant="outlined"
            />
          </Box>
        </div>

        {/* Edit button */}
        <button
          className="flex items-center border border-gray-200 rounded px-4 py-2 hover:bg-gray-50"
          onClick={() => handleSaveListing()}
        >
          <Edit size={16} className="mr-2" />
          <span>Save Listings</span>
        </button>
      </div>

      <div className="p-6 bg-white rounded-lg shadow-sm border mt-3 border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Personal Info Fields */}
          <div>
            <p className="text-sm text-gray-500">APE</p>
            <p className="flex items-center gap-2 font-medium">{property?.cadastralInfo?.ape}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Cadastral Income</p>
            <p className="flex items-center gap-2 font-medium">{property?.cadastralInfo?.cadastralIncome}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Cadastral Section</p>
            <p className="flex items-center gap-2 font-medium">{property?.cadastralInfo?.cadastralSection}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Category</p>
            <p className="flex items-center gap-2 font-medium">{property?.cadastralInfo?.category}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Commune Code</p>
            <p className="flex items-center gap-2 font-medium">{property?.cadastralInfo?.communeCode}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Energy Class</p>
            <p className="flex items-center gap-2 font-medium">{property?.cadastralInfo?.energyClass}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Particle</p>
            <p className="flex items-center gap-2 font-medium">{property?.cadastralInfo?.particle}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Sheet</p>
            <p className="flex items-center gap-2 font-medium">{property?.cadastralInfo?.sheet}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Subordinate</p>
            <p className="flex items-center gap-2 font-medium">{property?.cadastralInfo?.subordinate}</p>
          </div>
        </div>

        {/* Document Upload Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          {property?.visuraCatastale?.map((file, index) => (
            <div key={`document-${index}`} className="border rounded-lg p-4">
              <h3 className="text-sm font-semibold mb-2">Visura Societaria</h3>
              <div className="h-40 bg-gray-100 rounded flex items-center justify-center">
                {/* Optional: show file name */}
                <iframe
                  src={`${appConfig.FILE_URL}${file}`}
                  className="w-full h-full"
                  title={`Document Copy ${index}`}
                />
              </div>
              <div className="flex justify-between items-center mt-4">
                <button
                  onClick={() => handleDownloadContract(file)}
                  className="flex items-center gap-2 text-sm px-3 py-1 border rounded-md hover:bg-gray-100"
                >
                  <Download size={14} /> Download
                </button>
                <button className="flex items-center gap-2 text-sm px-3 py-1 border rounded-md hover:bg-gray-100">
                  <FileUp size={14} /> Update
                </button>
              </div>
            </div>
          ))}

          {property?.cinCisDocument?.map((file, index) => (
            <div key={`document-${index}`} className="border rounded-lg p-4">
              <h3 className="text-sm font-semibold mb-2">CIN/CIS Document</h3>
              <div className="h-40 bg-gray-100 rounded flex items-center justify-center">
                {/* Optional: show file name */}
                <iframe
                  src={`${appConfig.FILE_URL}${file}`}
                  className="w-full h-full"
                  title={`Document Copy ${index}`}
                />
              </div>
              <div className="flex justify-between items-center mt-4">
                <button
                  onClick={() => handleDownloadContract(file)}
                  className="flex items-center gap-2 text-sm px-3 py-1 border rounded-md hover:bg-gray-100"
                >
                  <Download size={14} /> Download
                </button>
                <button className="flex items-center gap-2 text-sm px-3 py-1 border rounded-md hover:bg-gray-100">
                  <FileUp size={14} /> Update
                </button>
              </div>
            </div>
          ))}

          {property?.rentalContract?.map((file, index) => (
            <div key={`document-${index}`} className="border rounded-lg p-4">
              <h3 className="text-sm font-semibold mb-2">Rental Contract</h3>
              <div className="h-40 bg-gray-100 rounded flex items-center justify-center">
                {/* Optional: show file name */}
                <iframe
                  src={`${appConfig.FILE_URL}${file}`}
                  className="w-full h-full"
                  title={`Document Copy ${index}`}
                />
              </div>
              <div className="flex justify-between items-center mt-4">
                <button
                  onClick={() => handleDownloadContract(file)}
                  className="flex items-center gap-2 text-sm px-3 py-1 border rounded-md hover:bg-gray-100"
                >
                  <Download size={14} /> Download
                </button>
                <button className="flex items-center gap-2 text-sm px-3 py-1 border rounded-md hover:bg-gray-100">
                  <FileUp size={14} /> Update
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-3">
          <p className="text-sm text-gray-500">Visura Date: {property?.visuraCatastaleInfo?.dataVisura}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Visura Number: {property?.visuraCatastaleInfo?.numeroVisura}</p>
        </div>
      </div>

      <div className="p-6 bg-white rounded-lg mt-3 shadow-sm border border-gray-200">
        {/* Header */}
        <div className="flex items-center mb-2">
          <Image className="text-indigo-600 mr-2" size={24} />
          <h2 className="text-xl font-bold">Property Images</h2>
        </div>

        {/* Description text */}
        <p className="text-gray-500 mb-6">Manage property photos</p>
        <ImageManager
          property={property}
          // existingMainPhoto="https://yourserver.com/files/main.jpg"
          // existingSelectedPhotos={[
          //   'https://yourserver.com/files/selected1.jpg',
          //   'https://yourserver.com/files/selected2.jpg',
          // ]}
          // existingOtherImages={['https://yourserver.com/files/extra1.jpg']}
        />

        {/* Action buttons */}
        {/* <div className="flex flex-wrap gap-3 mb-6">
          <button className="flex items-center bg-indigo-600 text-white rounded px-4 py-2 hover:bg-indigo-700">
            <Upload size={16} className="mr-2" />
            <span>Upload Images</span>
          </button>

          <button className="flex items-center border border-gray-300 rounded px-4 py-2 hover:bg-gray-50">
            <Download size={16} className="mr-2" />
            <span>Download All</span>
          </button>

          <button className="flex items-center border border-gray-300 rounded px-4 py-2 hover:bg-gray-50">
            <Download size={16} className="mr-2" />
            <span>Download All - with logo</span>
          </button>
        </div> */}

        {/* <div className="flex flex-wrap gap-3 mb-6">
          <label className="flex items-center bg-indigo-600 text-white rounded px-4 py-2 hover:bg-indigo-700 cursor-pointer">
            <Upload size={16} className="mr-2" />
            <span>Upload Images</span>
            <input type="file" multiple hidden accept="image/*" onChange={handleUpload} />
          </label>

          <button className="flex items-center border border-gray-300 rounded px-4 py-2 hover:bg-gray-50">
            <Download size={16} className="mr-2" />
            <span>Download All</span>
          </button>
        </div> */}

        {/* Main Photo Section */}
        {/* <div className="mb-6">
          <h3 className="font-medium mb-3">Main Photo</h3>
          <div className="relative w-full max-w-sm bg-gray-50 rounded overflow-hidden">
            <img src="/api/placeholder/400/300" alt="Main property image 1" className="w-full h-56" />
            <div className="absolute bottom-2 right-2 flex space-x-1">
              <button className="p-2 bg-gray-400 bg-opacity-70 rounded-full hover:bg-gray-500">
                <ArrowDown size={16} className="text-white" />
              </button>
              <button className="p-2 bg-gray-400 bg-opacity-70 rounded-full hover:bg-gray-500">
                <Trash2 size={16} className="text-white" />
              </button>
            </div>
          </div>
        </div> */}

        {/* <div className="mb-6">
          <h3 className="font-medium mb-3">Main Photo</h3>
          {mainPhoto ? renderImageCard(mainPhoto, 'main') : <p className="text-gray-500">No main photo selected</p>}
        </div> */}

        {/* Selected Photos Section */}
        {/* <div className="mb-6">
          <h3 className="font-medium mb-3">Selected Photos</h3>
          <div className="relative w-full max-w-sm bg-gray-50 rounded overflow-hidden">
            <img src="/api/placeholder/400/300" alt="Selected property image 1" className="w-full h-56" />
            <div className="absolute bottom-2 right-2 flex space-x-1">
              <button className="p-2 bg-gray-400 bg-opacity-70 rounded-full hover:bg-gray-500">
                <ArrowUp size={16} className="text-white" />
              </button>
              <button className="p-2 bg-gray-400 bg-opacity-70 rounded-full hover:bg-gray-500">
                <ArrowDown size={16} className="text-white" />
              </button>
              <button className="p-2 bg-gray-400 bg-opacity-70 rounded-full hover:bg-gray-500">
                <Trash2 size={16} className="text-white" />
              </button>
            </div>
          </div>
        </div> */}

        {/* <div className="mb-6">
          <h3 className="font-medium mb-3">Selected Photos</h3>
          {selectedPhotos.length > 0 ? (
            selectedPhotos.map((url) => renderImageCard(url, 'selected'))
          ) : (
            <p className="text-gray-500">No selected photos</p>
          )}
        </div> */}

        {/* Other Photos Section */}
        {/* <div>
          <h3 className="font-medium mb-3">Other Photos</h3>
          <p className="text-center text-gray-500 py-6">No other images</p>
        </div> */}

        {/* <div className="mb-6">
          <h3 className="font-medium mb-3">Other Photos</h3>
          {otherImages.length > 0 ? (
            otherImages.map((url) => renderImageCard(url, 'other'))
          ) : (
            <p className="text-gray-500">No other photos</p>
          )}
        </div> */}
      </div>

      <div className="p-6 bg-white rounded-lg shadow-sm border mt-3 border-gray-200">
        {/* Header */}
        <div className="flex items-center mb-2">
          <Shield className="text-indigo-600 mr-2" size={24} />
          <h2 className="text-xl font-bold">Police & Tourist Tax / Compliance</h2>
        </div>

        {/* Description text */}
        <p className="text-gray-500 mb-6">Login details and documentation</p>

        {/* Police Alloggiati Section */}
        <div className="mb-8">
          <h3 className="text-lg font-medium mb-4">Police Alloggiati</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <input
              type="text"
              placeholder="Username"
              value={policeUserName}
              onChange={(e) => setPoliceUserName(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded"
            />
            <input
              type="text"
              placeholder="Password"
              value={policePassword}
              onChange={(e) => setPolicePassword(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded"
            />
          </div>

          <div className="mb-4">
            <input
              value={policeApiKey}
              onChange={(e) => setPoliceApiKey(e.target.value)}
              type="text"
              placeholder="API Key"
              className="w-full px-3 py-2 border border-gray-300 rounded"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Login PDF */}
            {policePortalFiles.length === 0 ? (
              <div className="border border-gray-200 rounded p-4">
                <h4 className="font-medium mb-4">Login PDF</h4>
                <div className="flex flex-col items-center justify-center py-6 bg-gray-50 mb-4">
                  <FileText size={48} className="text-gray-300 mb-2" />
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <button
                    className="flex items-center justify-center border border-gray-300 rounded px-3 py-2 hover:bg-gray-50"
                    disabled
                  >
                    <Download size={16} className="mr-2" />
                    <span>Download</span>
                  </button>
                  <label className="flex items-center justify-center border border-gray-300 rounded px-3 py-2 hover:bg-gray-50 cursor-pointer">
                    <FileUp size={16} className="mr-2" />
                    <span>Upload</span>
                    <input type="file" hidden accept="image/*,application/pdf" onChange={handlePolicePortalUpload} />
                  </label>
                </div>
              </div>
            ) : (
              policePortalFiles.map((file, index) => (
                <div key={`document-${index}`} className="border rounded-lg p-4">
                  <h3 className="text-sm font-semibold mb-2">Login PDF</h3>
                  <div className="h-40 bg-gray-100 rounded flex items-center justify-center">
                    <iframe
                      src={`${appConfig.FILE_URL}${file}`}
                      className="w-full h-full"
                      title={`Document Copy ${index}`}
                    />
                  </div>
                  <div className="flex justify-between items-center mt-4">
                    <button
                      onClick={() => {
                        if (file) {
                          window.open(appConfig.FILE_URL + file, '_blank');
                        }
                      }}
                      className="flex items-center gap-2 text-sm px-3 py-1 border rounded-md hover:bg-gray-100"
                    >
                      <Download size={14} /> Download
                    </button>

                    <label className="flex items-center gap-2 text-sm px-3 py-1 border rounded-md hover:bg-gray-100 cursor-pointer">
                      <FileUp size={14} /> Update
                      <input type="file" hidden accept="image/*, application/pdf" onChange={handlePolicePortalUpload} />
                    </label>
                  </div>
                </div>
              ))
            )}

            {/* Police Alloggiati Request */}
            <div className="border border-gray-200 rounded p-4">
              <h4 className="font-medium mb-4">Police Alloggiati Request</h4>
              <div className="mb-4">
                <div className="relative">
                  <select className="w-full appearance-none px-3 py-2 border border-gray-300 rounded bg-white">
                    <option>Bari</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
                    <ChevronDown size={16} className="text-gray-500" />
                  </div>
                </div>
              </div>
              <button className="w-full flex items-center justify-center bg-indigo-600 text-white rounded px-4 py-2 hover:bg-indigo-700">
                <FileText size={16} className="mr-2" />
                <span>Generate Request</span>
              </button>
            </div>
          </div>
        </div>

        {/* Tourist Tax Login Section */}
        <div className="mb-8">
          <h3 className="text-lg font-medium mb-4">Tourist Tax Login</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <input
              type="text"
              placeholder="Username"
              value={tourismTaxLoginEmail}
              onChange={(e) => setTourismTaxLoginEmail(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded"
            />
            <input
              type="text"
              placeholder="Password"
              value={tourismTaxLoginPassword}
              onChange={(e) => setTourismTaxLoginPassword(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded"
            />
          </div>

          <div className="mb-4">
            <input
              value={tourismTaxLoginUrl}
              onChange={(e) => setTourismTaxLoginUrl(e.target.value)}
              type="url"
              placeholder="Login URL"
              className="w-full px-3 py-2 border border-gray-300 rounded"
            />
          </div>
        </div>

        {/* CIS & CIN Section */}
        <div>
          <h3 className="text-lg font-medium mb-4">CIS & CIN</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-gray-700 mb-1">CIN</label>
              <input
                type="text"
                value={cin}
                onChange={(e) => setCin(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">CIS</label>
              <input
                type="text"
                value={cis}
                onChange={(e) => setCis(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* CIN/CIS Document */}
            {/* <div className="border border-gray-200 rounded p-4">
              <h4 className="font-medium mb-4">CIN/CIS Document</h4>
              <div className="flex flex-col items-center justify-center py-6 bg-gray-50 mb-4">
                <FileText size={48} className="text-gray-300 mb-2" />
              </div>
              <div className="grid grid-cols-2 gap-2">
                <button className="flex items-center justify-center border border-gray-300 rounded px-3 py-2 hover:bg-gray-50">
                  <Download size={16} className="mr-2" />
                  <span>Download</span>
                </button>
                <button className="flex items-center justify-center border border-gray-300 rounded px-3 py-2 hover:bg-gray-50">
                  <FileUp size={16} className="mr-2" />
                  <span>Update</span>
                </button>
              </div>
            </div> */}

            {property?.cinCisDocument?.map((file, index) => (
              <div key={`document-${index}`} className="border rounded-lg p-4">
                <h3 className="text-sm font-semibold mb-2">CIN/CIS Document</h3>
                <div className="h-40 bg-gray-100 rounded flex items-center justify-center">
                  {/* Optional: show file name */}
                  <iframe
                    src={`${appConfig.FILE_URL}${file}`}
                    className="w-full h-full"
                    title={`Document Copy ${index}`}
                  />
                </div>
                <div className="flex justify-between items-center mt-4">
                  <button
                    onClick={() => handleDownloadContract(file)}
                    className="flex items-center gap-2 text-sm px-3 py-1 border rounded-md hover:bg-gray-100"
                  >
                    <Download size={14} /> Download
                  </button>
                  <button className="flex items-center gap-2 text-sm px-3 py-1 border rounded-md hover:bg-gray-100">
                    <FileUp size={14} /> Update
                  </button>
                </div>
              </div>
            ))}

            {/* Comunicazione Locazione Turistica */}
            <div className="border border-gray-200 rounded p-4">
              <h4 className="font-medium mb-4">Comunicazione Locazione Turistica</h4>

              <div className="flex flex-col items-center justify-center py-6 bg-gray-50 mb-4">
                {touristRentalCommunication ? (
                  <FileText size={48} className="text-indigo-400 mb-2" />
                ) : (
                  <FileText size={48} className="text-gray-300 mb-2" />
                )}
                <p className="text-gray-500 text-sm">
                  {touristRentalCommunication ? 'File uploaded' : 'No file uploaded'}
                </p>
              </div>

              <div className="grid grid-cols-2 gap-2">
                <button
                  type="button"
                  onClick={() => {
                    if (touristRentalCommunication) {
                      window.open(appConfig.FILE_URL + touristRentalCommunication, '_blank');
                    }
                  }}
                  disabled={!touristRentalCommunication}
                  className="flex items-center justify-center border border-gray-300 rounded px-3 py-2 hover:bg-gray-50 disabled:opacity-50"
                >
                  <Download size={16} className="mr-2" />
                  <span>Download</span>
                </button>

                <label className="flex items-center justify-center border border-gray-300 rounded px-3 py-2 hover:bg-gray-50 cursor-pointer">
                  <FileUp size={16} className="mr-2" />
                  <span>Update</span>
                  <input type="file" hidden accept="application/pdf,image/*" onChange={handleTouristRentalUpload} />
                </label>
              </div>
            </div>

            {/* Compliance Sign */}
            <div className="border border-gray-200 rounded p-4">
              <h4 className="font-medium mb-4">Compliance Sign</h4>
              <div className="mb-4">
                <div className="relative">
                  <select className="w-full appearance-none px-3 py-2 border border-gray-300 rounded bg-white">
                    <option>Large Sign</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
                    <ChevronDown size={16} className="text-gray-500" />
                  </div>
                </div>
              </div>
              <button className="w-full flex items-center justify-center bg-indigo-600 text-white rounded px-4 py-2 hover:bg-indigo-700">
                <Download size={16} className="mr-2" />
                <span>Download Sign</span>
              </button>
            </div>
          </div>
          <button
            className="flex items-center border border-gray-200 rounded px-4 py-2 hover:bg-gray-50 mt-4"
            onClick={() => handleSavePoliceTouristTax()}
          >
            <Edit size={16} className="mr-2" />
            <span>Save</span>
          </button>
        </div>
      </div>

      <div className="w-full mt-3 bg-white rounded-lg border border-gray-200 p-6">
        <div className="flex items-center gap-2 mb-2">
          <FileText className="text-indigo-500" size={20} />
          <h2 className="text-lg font-medium text-gray-800">Additional Documents</h2>
        </div>

        <p className="text-gray-500 mb-6">Additional property documentation</p>
        {additionalDocuments?.length === 0 && (
          <div className="border border-gray-100 rounded-lg bg-gray-50 p-10 text-center mb-6">
            <div className="flex justify-center mb-4">
              <div className="p-4 rounded-full bg-gray-100">
                <FileText className="text-gray-400" size={24} />
              </div>
            </div>
            <p className="text-gray-500 font-medium mb-1">No additional documents added yet</p>
            <p className="text-gray-400 text-sm">Click "Add Document" to add property-related documentation</p>
          </div>
        )}
        {additionalDocuments?.length > 0 && (
          <div className="grid grid-cols-3 gap-4 mb-6">
            {additionalDocuments.map((doc, idx) => (
              <div key={idx} className="border p-4 rounded relative">
                <iframe
                  src={`${appConfig.FILE_URL}${doc}`}
                  className="w-full h-40 rounded mb-2"
                  title={`Document ${idx}`}
                />

                {/* <button
                  onClick={() => handleDeleteDocument(doc)}
                  className="absolute bottom-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                  title="Delete Document"
                >
                  <Trash size={16} />
                </button> */}

                <button
                  onClick={() => handleDeleteDocument(doc)}
                  className="absolute bottom-2 right-2 p-2 bg-gray-400 bg-opacity-70 rounded-full hover:bg-gray-500"
                >
                  <Trash2 size={16} className="text-white" />
                </button>
              </div>
            ))}
          </div>
        )}

        <button
          type="button"
          onClick={() => additionalDocRef.current.click()}
          className="bg-indigo-500 hover:bg-indigo-600 text-white font-medium py-3 px-4 rounded-lg flex items-center justify-center gap-2 w-full sm:w-auto"
        >
          <FileText size={18} />
          Add Document
        </button>
        <input
          type="file"
          ref={additionalDocRef}
          hidden
          multiple
          accept="image/*,application/pdf"
          onChange={handleAdditionalDocUpload}
        />
      </div>
    </>
  );
}
